var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['confirm-btn', { hide: !_vm.showCo }]},[_c('div',{on:{"click":_vm.del}},[_vm._v("Eyða leit")]),_c('div',{staticClass:"color-primary",on:{"click":_vm.cancelConfirm}},[_vm._v("Hætta við")])])}
var staticRenderFns = []

export { render, staticRenderFns }